export default __webpack_public_path__ + "static/media/javascript-4.13ceb963.svg";